import React, { useState, useContext } from 'react';
import { AlumnosContext } from '../../../context/alumnos/AlumnosContext';
import { FormSelect, FormLabel, SubmitButton } from '../../../assets/styled';
import { renderGrupoOptions } from './Formulario';

export default function BulkUpdateModal({ isOpen, onClose, selectedIds }) {
	const { updateAlumnosBulk } = useContext(AlumnosContext);
	const [formData, setFormData] = useState({
		categoria: '',
		grupo: '',
		activo: 'no_change',
	});

	const handleChange = (e) => {
		let value = e.target.value;
		if (e.target.name === 'activo') {
			if (value === 'true') value = true;
			else if (value === 'false') value = false;
		}

		setFormData({
			...formData,
			[e.target.name]: value,
		});
	};

	const handleSubmit = async (e) => {
		e.preventDefault();
		const finalData = { ...formData };
		if (finalData.activo === 'no_change') delete finalData.activo;
		if (!finalData.categoria) delete finalData.categoria;
		if (!finalData.grupo) delete finalData.grupo;

		await updateAlumnosBulk(selectedIds, finalData);
		onClose();
	};

	if (!isOpen) return null;

	return (
		<div
			className='modal fade show'
			style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.5)' }}
			tabIndex='-1'
		>
			<div className='modal-dialog'>
				<div className='modal-content'>
					<div className='modal-header'>
						<h5 className='modal-title'>Modificar {selectedIds.length} Alumnos</h5>
						<button type='button' className='btn-close' onClick={onClose}></button>
					</div>
					<div className='modal-body'>
						<form onSubmit={handleSubmit}>
							<div className='mb-3'>
								<FormLabel>CATEGORIA</FormLabel>
								<FormSelect
									name='categoria'
									value={formData.categoria}
									onChange={handleChange}
								>
									<option value=''>Sin cambios</option>
									<option value='INFANTIL'>INFANTIL</option>
									<option value='JUVENIL'>JUVENIL</option>
									<option value='FEMENINO'>FEMENINO</option>
									<option value='MAYORES'>MAYORES</option>
								</FormSelect>
							</div>
							<div className='mb-3'>
								<FormLabel>GRUPO</FormLabel>
								<FormSelect
									name='grupo'
									value={formData.grupo}
									onChange={handleChange}
								>
									<option value=''>Sin cambios</option>
									{renderGrupoOptions(formData.categoria)}
								</FormSelect>
							</div>
							<div className='mb-3'>
								<FormLabel>ESTADO</FormLabel>
								<FormSelect
									name='activo'
									value={formData.activo}
									onChange={handleChange}
								>
									<option value='no_change'>Sin cambios</option>
									<option value='true'>Activo</option>
									<option value='false'>Inactivo</option>
								</FormSelect>
							</div>
							<div className='mt-4'>
								<SubmitButton type='submit'>Guardar Cambios</SubmitButton>
							</div>
						</form>
					</div>
				</div>
			</div>
		</div>
	);
}
